<template>
  <div id="schedules-index" v-if="canSee('list')">
    <vs-popup title="Remover Agendamento de Mensagem" :active.sync="dataToDelete.modalActive" class="sizePopup">
      <p>Deseja realmente cancelar o envio da mensagem para <strong>{{ dataToDelete.customerName }}</strong>?</p>
      <div class="w-full d-flex justify-content-flex-end">
        <vs-button color="danger" @click.prevent="deleteContactSchedule">Remover</vs-button>
      </div>
    </vs-popup>

    <schedules-view-sidebar
        :isSidebarActive="dataToUpdate.sideBarIsActive"
        @closeSidebar="toggleDataSidebar"
        :schedule="dataToUpdate"
    />

    <vs-table
        ref="table"
        pagination
        noDataText="Sem dados disponíveis"
        @sort="sortFilter"
        v-model="selected"
        :data="listOfSchedules"
        :max-items="itemsPerPage"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between" >
        <vs-dropdown  vs-trigger-click  class="cursor-pointer mb-4 mr-4" >
          <div class="
              p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
              cursor-pointer flex items-center justify-between font-medium
          ">
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
                  {{
                listOfSchedules.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : listOfSchedules.length
              }} of {{ queriedItems }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <vs-input icon="search" 
          v-model="searchUser" 
          class="search-input" 
          @input="searchFilter()"
        />

      </div>

      <template slot="thead">
        <vs-th sort-key="customers.name">
          Contato
        </vs-th>
        <vs-th sort-key="users.name">
          Usuário Responsável
        </vs-th>
        <vs-th sort-key="customers.phone_number">
          Número do Contato
        </vs-th>
        <vs-th sort-key="instances.name">
          Conexão
        </vs-th>
        <vs-th sort-key="instance_id">
          Número da Conexão
        </vs-th>
        <vs-th sort-key="triggering_date">
          Data de Agendamento
        </vs-th>
        <vs-th sort-key="is_sent">
          Foi disparada?
        </vs-th>
        <vs-th>
          Ações
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="tr.customer.name">
              <p class="text-center font-medium">{{ tr.customer.name }}</p>
            </vs-td>

            <vs-td :data="tr.user ? tr.user.name : null">
              <p class="text-center">{{ tr.user ? tr.user.name : 'Usuário Deletado' }}</p>
            </vs-td>

            <vs-td :data="tr.customer.phone_number">
              <p class="font-medium">{{ parsePhone(tr.customer.phone_number) }}</p>
            </vs-td>

            <vs-td v-if="tr.instance" :data="tr.instance.name">
              <p class="text-center">{{ tr.instance.name }}</p>
            </vs-td>

            <vs-td v-else data="Conexão Excluída">
              <p class="text-center">Conexão Excluída</p>
            </vs-td>

            <vs-td :data="tr.instance_id" class="text-center">
              <p class="font-medium text-center">{{ tr.instance_id }}</p>
            </vs-td>

            <vs-td :data="tr.triggering_date ">
              <p class="font-medium text-center">{{ parseDate(tr.triggering_date) }}</p>
            </vs-td>

            <vs-td :data="tr.is_sent" class="text-center">
                <vs-chip :color="colorWasSend(Boolean(tr.is_sent))"> {{ tr.is_sent == true ? 'Sim' : 'Não' }}</vs-chip>
            </vs-td>

            <vs-td v-if="!tr.is_sent" class="whitespace-no-wrap">
              <feather-icon
                  v-if="canSee('update')"
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="updateScheduleSidebar(tr)"
              />

              <feather-icon
                  v-if="canSee('delete')"
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="removeScheduleModal(tr)"
              />
            </vs-td>

            <vs-td v-else class="whitespace-no-wrap">
              <vs-chip color="success"> Já Enviado </vs-chip>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>

import moment from 'moment';
import { fetchAll, deleteContactSchedule } from '@/http/requests/contactSchedule';
import { maskPhoneNumber, getTimeZone} from '@/utils';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import SchedulesViewSidebar from "@/views/schedules/SchedulesViewSidebar.vue";
import { hasPermission } from '@/utils'

export default {
  name: "Schedules",
  components: {
    VuePerfectScrollbar,
    SchedulesViewSidebar
  },
  data() {
    return {
      selected: [],
      listOfSchedules: [],
      isMounted: false,
      totalPages: 0,
      itemsPerPage: 4,
      dataToDelete: {
        targetId: null,
        customerName: null,
        modalActive: false,
      },
      dataToUpdate: {
        data: {},
        newText: '',
        newDate: '',
        newTime: '',
        targetId: 0,
        sideBarIsActive: false,
        messageTemplateName: null,
      },
      sort: {
        name: undefined,
        value: undefined
      },
      searchUser: ''
    }
  },
  methods: {
    canSee(action) {
        return hasPermission(`scheduled-message-${action}`)
    },
    toggleDataSidebar( val = false ) {
      this.fetchAllSchedules(this.sort.name, this.sort.value);
      this.dataToUpdate.sideBarIsActive = val
    },
    removeScheduleModal(tr) {
      this.dataToDelete = {
        targetId: tr.id,
        modalActive: true,
        customerName: tr.customer.name,
      };
    },
    updateScheduleSidebar(tr) {
      let hour = tr.triggering_date
      let formattedHours = moment(hour).format('HH:mm')
      let hourTimeZone = getTimeZone(formattedHours, 'schedules', true) 
      this.dataToUpdate = {
        data: tr,
        targetId: tr.id,
        sideBarIsActive: true,
        newText: tr.text_message,
        newDate: this.parseDate(tr.triggering_date).split(' ')[1],
        newTime: hourTimeZone,
        messageTemplateName: tr.message_template_name,
      }
    },
    checkIfCanSee(data) {
      const currentUserRole = this.userInfo.role.name;
      if (currentUserRole === 'administrador') { return data; }

      return data.filter((object) => {
        return object.user_id === this.userInfo.id
      });
    },
    fetchAllSchedules(sortName = 'id', sortType = 'DESC') {
      fetchAll(sortName, sortType).then((response) => {
        const data = response.data.data.contactSchedule;
        const listOfSchedules = this.checkIfCanSee(data);

        for (let index = 0; index < listOfSchedules.length; index++) {
          listOfSchedules[index].customer.phone_number = this.removeSymbols(listOfSchedules[index].customer.phone_number);        
        }
        
        this.totalPages = Math.ceil(listOfSchedules.length / this.itemsPerPage);
        return this.listOfSchedules = listOfSchedules;
      })
      .catch((error) => {
        console.log(error)
        return this.$vs.notify({
          color: 'danger',
          title: 'Erro',
          text: 'Houve algum erro ao carregar mensagens agendadas!'
        });
      })
    },
    parseDate(date) {
      let splited = date.split(' ')[0].split('-');
      let newDate = splited[2] + '/' + splited[1] + '/' + splited[0]
      let hours = moment(date).format('HH:mm')
      let hoursTimeZone = getTimeZone(hours, 'schedules', true)
      return hoursTimeZone  + ' ' + newDate;
    },
    parsePhone(phone) {
      return maskPhoneNumber(phone);
    },
    colorWasSend(response) {
      return response ? 'success' : 'danger';
    },
    deleteContactSchedule() {
      deleteContactSchedule(this.dataToDelete).then(() => {
        this.dataToDelete = {
          targetId: null,
          customerName: null,
          modalActive: false,
        }

        this.fetchAllSchedules(this.sort.name, this.sort.value);

        return this.$vs.notify({
          color: 'success',
          title: 'Sucesso',
          text: 'O agendamento foi cancelado com sucesso!'
        });
      })
      .catch((error) => {
        console.error(error)
        return this.$vs.notify({
          color: 'danger',
          title: 'Erro',
          text: 'Houve algum erro ao cancelar agendamento!'
        });
      });
    },
    async sortFilter(sortName) {
      if (this.sort.name !== sortName) {
        this.sort = {
          name: sortName,
          value: 'ASC'
        }
      } else if (this.sort.name === sortName && this.sort.value === 'ASC') {
        this.sort = {
          name: sortName,
          value: 'DESC'
        }
      } else if (this.sort.name === sortName && this.sort.value === 'DESC') {
        this.sort = {
          name: undefined,
          value: undefined
        }
      }
      this.fetchAllSchedules(this.sort.name, this.sort.value);
    },
    searchFilter() {
      if (this.searchUser.startsWith('(') || (this.searchUser.length > 5 && this.searchUser[5] === '9')) {
        this.$refs.table.searchx = this.removeSymbols(this.searchUser);
        return;
      }
      this.$refs.table.searchx = this.searchUser;
    },
    removeSymbols(str) {
      return str.replace(/[() -]/g, "");
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.AppActiveUser
    },
    currentPage() {
      if (this.isMounted) { return this.$refs.table.currentx } return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.listOfSchedules.length
    }
  },
  mounted() {
    this.isMounted = true;
    this.fetchAllSchedules(this.sort.name, this.sort.value);
  }
}
</script>


<style lang="scss">
#schedules-index {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
        box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
        td{
          padding: 10px;
          &:first-child{
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }
          &:last-child{
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
          &.img-container {
            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check{
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
